module.exports = __webpack_public_path__ + "img/image19.115c708b.png";